import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { LandingPageIds } from '@bridebook/web/lib/landing/webflow-page-urls';

interface FaqQuestion {
  question: string;
  answer: string;
}

type FaqData = Partial<
  Record<
    LandingPageIds,
    () => {
      header: string;
      subheader: string;
      button: string;
      data: FaqQuestion[];
    }
  >
>;

export const getFaqData = (): FaqData => {
  const i18n = getI18n();
  return {
    [LandingPageIds.weddingPlanningTools]: () => ({
      header: i18n.t('landing:faq.weddingPlanningTools.header'),
      subheader: i18n.t('landing:faq.weddingPlanningTools.subheader'),
      button: i18n.t('landing:faq.weddingPlanningTools.button'),
      data: [
        {
          question: i18n.t('landing:faq.weddingPlanningTools.1.question'),
          answer: i18n.t('landing:faq.weddingPlanningTools.1.response'),
        },
        {
          question: i18n.t('landing:faq.weddingPlanningTools.2.question'),
          answer: i18n.t('landing:faq.weddingPlanningTools.2.response'),
        },
        {
          question: i18n.t('landing:faq.weddingPlanningTools.3.question'),
          answer: i18n.t('landing:faq.weddingPlanningTools.3.response'),
        },
        {
          question: i18n.t('landing:faq.weddingPlanningTools.4.question'),
          answer: i18n.t('landing:faq.weddingPlanningTools.4.response'),
        },
        {
          question: i18n.t('landing:faq.weddingPlanningTools.5.question'),
          answer: i18n.t('landing:faq.weddingPlanningTools.5.response'),
        },
      ],
    }),

    [LandingPageIds.toolsChecklist]: () => ({
      header: i18n.t('landing:faq.checklist.header'),
      subheader: i18n.t('landing:faq.checklist.subheader'),
      button: i18n.t('landing:faq.checklist.button'),
      data: [
        {
          question: i18n.t('landing:faq.checklist.1.question'),
          answer: i18n.t('landing:faq.checklist.1.response'),
        },
        {
          question: i18n.t('landing:faq.checklist.2.question'),
          answer: i18n.t('landing:faq.checklist.2.response'),
        },
        {
          question: i18n.t('landing:faq.checklist.3.question'),
          answer: i18n.t('landing:faq.checklist.3.response'),
        },
        {
          question: i18n.t('landing:faq.checklist.4.question'),
          answer: i18n.t('landing:faq.checklist.4.response'),
        },
        {
          question: i18n.t('landing:faq.checklist.5.question'),
          answer: i18n.t('landing:faq.checklist.5.response'),
        },
        {
          question: i18n.t('landing:faq.checklist.6.question'),
          answer: i18n.t('landing:faq.checklist.6.response'),
        },
        {
          question: i18n.t('landing:faq.checklist.7.question'),
          answer: i18n.t('landing:faq.checklist.7.response'),
        },
      ],
    }),

    [LandingPageIds.toolsBudget]: () => ({
      header: i18n.t('landing:faq.budget.header'),
      subheader: i18n.t('landing:faq.budget.subheader'),
      button: i18n.t('landing:faq.budget.button'),
      data: [
        {
          question: i18n.t('landing:faq.budget.1.question'),
          answer: i18n.t('landing:faq.budget.1.response'),
        },
        {
          question: i18n.t('landing:faq.budget.2.question'),
          answer: i18n.t('landing:faq.budget.2.response'),
        },
        {
          question: i18n.t('landing:faq.budget.3.question'),
          answer: i18n.t('landing:faq.budget.3.response'),
        },
        {
          question: i18n.t('landing:faq.budget.4.question'),
          answer: i18n.t('landing:faq.budget.4.response'),
        },
        {
          question: i18n.t('landing:faq.budget.5.question'),
          answer: i18n.t('landing:faq.budget.5.response'),
        },
      ],
    }),

    [LandingPageIds.toolsGuestlist]: () => ({
      header: i18n.t('landing:faq.guestlist.header'),
      subheader: i18n.t('landing:faq.guestlist.subheader'),
      button: i18n.t('landing:faq.guestlist.button'),
      data: [
        {
          question: i18n.t('landing:faq.guestlist.1.question'),
          answer: i18n.t('landing:faq.guestlist.1.response'),
        },
        {
          question: i18n.t('landing:faq.guestlist.2.question'),
          answer: i18n.t('landing:faq.guestlist.2.response'),
        },
        {
          question: i18n.t('landing:faq.guestlist.3.question'),
          answer: i18n.t('landing:faq.guestlist.3.response'),
        },
        {
          question: i18n.t('landing:faq.guestlist.4.question'),
          answer: i18n.t('landing:faq.guestlist.4.response'),
        },
        {
          question: i18n.t('landing:faq.guestlist.5.question'),
          answer: i18n.t('landing:faq.guestlist.5.response'),
        },
        {
          question: i18n.t('landing:faq.guestlist.6.question'),
          answer: i18n.t('landing:faq.guestlist.6.response'),
        },
      ],
    }),

    [LandingPageIds.toolsShortlist]: () => ({
      header: i18n.t('landing:faq.shortlist.header'),
      subheader: i18n.t('landing:faq.shortlist.subheader'),
      button: i18n.t('landing:faq.shortlist.button'),
      data: [
        {
          question: i18n.t('landing:faq.shortlist.1.question'),
          answer: i18n.t('landing:faq.shortlist.1.response'),
        },
        {
          question: i18n.t('landing:faq.shortlist.2.question'),
          answer: i18n.t('landing:faq.shortlist.2.response'),
        },
        {
          question: i18n.t('landing:faq.shortlist.3.question'),
          answer: i18n.t('landing:faq.shortlist.3.response'),
        },
        {
          question: i18n.t('landing:faq.shortlist.4.question'),
          answer: i18n.t('landing:faq.shortlist.4.response'),
        },
        {
          question: i18n.t('landing:faq.shortlist.5.question'),
          answer: i18n.t('landing:faq.shortlist.5.response'),
        },
      ],
    }),

    [LandingPageIds.weddingSuppliers]: () => ({
      header: i18n.t('landing:faq.weddingSuppliers.header'),
      subheader: i18n.t('landing:faq.weddingSuppliers.subheader'),
      button: i18n.t('landing:faq.weddingSuppliers.button'),
      data: [
        {
          question: i18n.t('landing:faq.weddingSuppliers.1.question'),
          answer: i18n.t('landing:faq.weddingSuppliers.1.response'),
        },
        {
          question: i18n.t('landing:faq.weddingSuppliers.2.question'),
          answer: i18n.t('landing:faq.weddingSuppliers.2.response'),
        },
        {
          question: i18n.t('landing:faq.weddingSuppliers.3.question'),
          answer: i18n.t('landing:faq.weddingSuppliers.3.response'),
        },
        {
          question: i18n.t('landing:faq.weddingSuppliers.4.question'),
          answer: i18n.t('landing:faq.weddingSuppliers.4.response'),
        },
        {
          question: i18n.t('landing:faq.weddingSuppliers.5.question'),
          answer: i18n.t('landing:faq.weddingSuppliers.5.response'),
        },
        {
          question: i18n.t('landing:faq.weddingSuppliers.6.question'),
          answer: i18n.t('landing:faq.weddingSuppliers.6.response'),
        },
      ],
    }),

    [LandingPageIds.localeHome]: () => ({
      header: i18n.t('landing:faq.home.header'),
      subheader: i18n.t('landing:faq.home.subheader'),
      button: i18n.t('landing:faq.home.button'),
      data: [
        {
          question: i18n.t('landing:faq.home.1.question'),
          answer: i18n.t('landing:faq.home.1.response'),
        },
        {
          question: i18n.t('landing:faq.home.2.question'),
          answer: i18n.t('landing:faq.home.2.response'),
        },
        {
          question: i18n.t('landing:faq.home.3.question'),
          answer: i18n.t('landing:faq.home.3.response'),
        },
        {
          question: i18n.t('landing:faq.home.4.question'),
          answer: i18n.t('landing:faq.home.4.response'),
        },
        {
          question: i18n.t('landing:faq.home.5.question'),
          answer: i18n.t('landing:faq.home.5.response'),
        },
      ],
    }),

    [LandingPageIds.weddingIdeasInspiration]: () => ({
      header: i18n.t('landing:faq.advice.header'),
      subheader: i18n.t('landing:faq.advice.subheader'),
      button: i18n.t('landing:faq.advice.button'),
      data: [
        {
          question: i18n.t('landing:faq.advice.1.question'),
          answer: i18n.t('landing:faq.advice.1.response'),
        },
        {
          question: i18n.t('landing:faq.advice.2.question'),
          answer: i18n.t('landing:faq.advice.2.response'),
        },
        {
          question: i18n.t('landing:faq.advice.3.question'),
          answer: i18n.t('landing:faq.advice.3.response'),
        },
        {
          question: i18n.t('landing:faq.advice.4.question'),
          answer: i18n.t('landing:faq.advice.4.response'),
        },
      ],
    }),

    [LandingPageIds.weddingWebsite]: () => ({
      header: i18n.t('landing:faq.weddingWebsite.header'),
      subheader: i18n.t('landing:faq.weddingWebsite.subheader'),
      button: i18n.t('landing:faq.weddingWebsite.button'),
      data: [
        {
          question: i18n.t('landing:faq.weddingWebsite.1.question'),
          answer: i18n.t('landing:faq.weddingWebsite.1.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsite.2.question'),
          answer: i18n.t('landing:faq.weddingWebsite.2.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsite.3.question'),
          answer: i18n.t('landing:faq.weddingWebsite.3.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsite.4.question'),
          answer: i18n.t('landing:faq.weddingWebsite.4.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsite.5.question'),
          answer: i18n.t('landing:faq.weddingWebsite.5.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsite.6.question'),
          answer: i18n.t('landing:faq.weddingWebsite.6.response'),
        },
      ],
    }),

    [LandingPageIds.weddingWebsiteThemesAndFonts]: () => ({
      header: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.header'),
      subheader: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.subheader'),
      button: i18n.t('landing:faq.weddingWebsite.button'),
      data: [
        {
          question: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.1.question'),
          answer: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.1.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.2.question'),
          answer: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.2.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.3.question'),
          answer: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.3.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.4.question'),
          answer: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.4.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.5.question'),
          answer: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.5.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.6.question'),
          answer: i18n.t('landing:faq.weddingWebsiteThemesAndFonts.6.response'),
        },
      ],
    }),

    [LandingPageIds.weddingWebsiteWhatYouCanDo]: () => ({
      header: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.header'),
      subheader: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.subheader'),
      button: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.button'),
      data: [
        {
          question: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.1.question'),
          answer: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.1.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.2.question'),
          answer: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.2.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.3.question'),
          answer: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.3.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.4.question'),
          answer: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.4.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.5.question'),
          answer: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.5.response'),
        },
        {
          question: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.6.question'),
          answer: i18n.t('landing:faq.weddingWebsiteWhatYouCanDo.6.response'),
        },
      ],
    }),
    [LandingPageIds.weddingGiftLists]: () => ({
      header: i18n.t('landing:faq.giftLists.header'),
      subheader: i18n.t('landing:faq.giftLists.subheader'),
      button: i18n.t('landing:faq.giftLists.button'),
      data: [
        {
          question: i18n.t('landing:faq.giftLists.1.question'),
          answer: i18n.t('landing:faq.giftLists.1.response'),
        },
        {
          question: i18n.t('landing:faq.giftLists.2.question'),
          answer: i18n.t('landing:faq.giftLists.2.response'),
        },
        {
          question: i18n.t('landing:faq.giftLists.3.question'),
          answer: i18n.t('landing:faq.giftLists.3.response'),
        },
        {
          question: i18n.t('landing:faq.giftLists.4.question'),
          answer: i18n.t('landing:faq.giftLists.4.response'),
        },
        {
          question: i18n.t('landing:faq.giftLists.5.question'),
          answer: i18n.t('landing:faq.giftLists.5.response'),
        },
        {
          question: i18n.t('landing:faq.giftLists.6.question'),
          answer: i18n.t('landing:faq.giftLists.6.response'),
        },
        {
          question: i18n.t('landing:faq.giftLists.7.question'),
          answer: i18n.t('landing:faq.giftLists.7.response'),
        },
      ],
    }),
  };
};
